import { SocialPerson } from '@/models/Person';
import { getDisplayName } from '@/services/UtilService';
import { ApplicationState } from '@/store';
import { deleteFollowerRequest, setFollowerRequest } from '@/store/followers/action';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import PersonImage from '../PersonImage';
import './style.scss';

interface Props {
    person: SocialPerson;
}

const PersonCard: React.FC<Props> = ({ person }: Props) => {
    const { strings, myPersonId } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
        myPersonId: state.identity.data.person.id,
    }));

    const dispatch = useDispatch();

    const [following, setFollowing] = useState<boolean>(person.followedByMe);

    const history = useHistory();

    const follow = () => {
        setFollowing(true);
        dispatch(setFollowerRequest(person.id as number));
    };

    const unFollow = () => {
        setFollowing(false);
        dispatch(deleteFollowerRequest(person.id as number));
    };

    const navigateToProfile = () => history.push(`/profile/${person.id}/info`);

    return (
        <div className="person-card-container" onClick={navigateToProfile}>
            <div className="person-card-container-header">
                <PersonImage alt={person.firstName} size={64} src={person.thumbnail} />
            </div>
            <div className="person-card-container-content">
                <div className="person-card-container-content-name" title={getDisplayName(person)}>
                    {getDisplayName(person)}
                </div>
                <div className="person-card-container-content-positon" title={person.position}>
                    {person.position}
                </div>
            </div>
            <div className="person-card-container-footer">
                <button
                    className={following ? 'person-card-container-footer-folling' : 'person-card-container-footer-follow'}
                    disabled={person.id === myPersonId}
                    onClick={(event) => {
                        event.stopPropagation();
                        following ? unFollow() : follow();
                    }}
                    type="button"
                >
                    {following ? strings.FOLLOWING : strings.FOLLOW}
                </button>
            </div>
        </div>
    );
};

export default PersonCard;
